import Router from 'next/router';

const WhyHomiiLifeMenuComponent = () => {
    
    const onLiveYourBestLifeClick = () => {
        Router.push('/live/live-your-best-life').then(() => window.scrollTo(0, 0));
    };

    const onAboutHomiiClick = () => {
        Router.push('/about').then(() => window.scrollTo(0, 0));
    };

    const onOurAppClick = () => {
        Router.push('/live/our-app').then(() => window.scrollTo(0, 0));
    };

    const onYourOfficeClick = () => {
        Router.push('/work/your-office').then(() => window.scrollTo(0, 0));
    };

    const onOwnYourCityClick = () => {
        Router.push('/play/own-your-city').then(() => window.scrollTo(0, 0));
    };

    const onGalleryClick = () => {
        Router.push('/play/gallery').then(() => window.scrollTo(0, 0));
    };

    return (
        <>
            <div className='menu-grid-container menu-grid-item menu-grid-md-12 menu-grid-lg-6'>
                <div className="menu-grid-item menu-grid-md-true">
                    <h5 style={{ marginBottom: '15px' }}>#Live</h5>
                    <ul className='menu-list-root menu-list-padding'>
                        <div className="menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button"
                            tabIndex="0" role="button" aria-disabled="false" id="menu-link-about" onClick={onAboutHomiiClick}>
                            <div className="menu-list-item-text-root menu-link">
                                <span
                                    className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                                    About HOMii
                                </span>
                            </div>
                            <span className="menu-touch-ripple-root"></span>
                        </div>

                        <div className="menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button"
                            tabIndex="0" role="button" aria-disabled="false" id="menu-link-welcome-to-your-best-life" onClick={onLiveYourBestLifeClick}>
                            <div className="menu-list-item-text-root menu-link">
                                <span
                                    className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                                    Welcome To Your Best Life
                                </span>
                            </div>
                            <span className="menu-touch-ripple-root"></span>
                        </div>
                        <div className="menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button"
                            tabIndex="0" role="button" aria-disabled="false" id="menu-link-do-life-on-our-app" onClick={onOurAppClick}>
                            <div className="menu-list-item-text-root menu-link">
                                <span
                                    className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                                    Do Life On Our App
                                </span>
                            </div>
                            <span className="menu-touch-ripple-root"></span>
                        </div>
                    </ul>
                </div>

                <div className="menu-grid-item menu-grid-md-true">
                    <h5 style={{ marginBottom: '15px' }}>
                        #Work
                    </h5>
                    <ul className="menu-list-root menu-list-padding">
                        <div className="menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button"
                            tabIndex="0" role="button" aria-disabled="false" id="menu-link-your-homii-office" onClick={onYourOfficeClick}>
                            <div className="menu-list-item-text-root menu-link">
                                <span
                                    className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                                    Your HOMii Office
                                </span>
                            </div>
                            <span className="menu-touch-ripple-root"></span>
                        </div>
                    </ul>
                </div>

                <div className="menu-grid-item menu-grid-md-true">
                    <h5 style={{ marginBottom: '15px' }}>#Play</h5>
                    <ul className="menu-list-root menu-list-padding">
                        <div className="menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button"
                            tabIndex="0" role="button" aria-disabled="false" id="menu-link-own-your-city" onClick={onOwnYourCityClick}>
                            <div className="menu-list-item-text-root menu-link">
                                <span
                                    className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                                    Own Your City
                                </span>
                            </div>
                            <span className="menu-touch-ripple-root"></span>
                        </div>
                        <div className="menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button"
                            tabIndex="0" role="button" aria-disabled="false" id="menu-link-gallery" onClick={onGalleryClick}>
                            <div className="menu-list-item-text-root menu-link">
                                <span
                                    className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                                    Gallery
                                </span>
                            </div>
                            <span className="menu-touch-ripple-root"></span>
                        </div>
                    </ul>
                </div> 
            </div>           
        </>

    );
};

export default WhyHomiiLifeMenuComponent;
